import { configureStore } from '@reduxjs/toolkit'

import createRootReducer from '@redux/rootReducer'
import lastModifiedMiddleware from '@redux/middleware/lastModified'

// @ts-expect-error TS7006
const rootReducer = (state, action) => {
  if (action.type === 'realbase/currentUser/RESET_STORE'){
    state = undefined
  }

  return createRootReducer(state, action)
}

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware({ immutableCheck: false }).concat(lastModifiedMiddleware),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store
